import React from 'react';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import { ConteudoPlanoAtual } from './ConteudoPlanoAtual';

const Page = () => {
    return (
        <LayoutUsuario>
            <ConteudoPlanoAtual />
        </LayoutUsuario>
    );
};

export default Page;
